{
  "AllNotifications": "Allle Benachrichtigungen",
  "NoLinkNotification": "Kein Link verfügbar für diese Benachrichtigung",
  "ViewAllAnnouncementTab": "Ankündigungen",
  "ViewallNotificationTab": "Benachrichtigungen",
  "preferences": "Voreinstellungen bearbeiten"
}
